<template>
	<component :is="tag">
		<slot>remove</slot>
	</component>
</template>

<script>
export default {
	provide() {
		return {
			[ Symbol.for( 'carousel' ) ]: this,
		};
	},
	props: {
		tag: {
			type: String,
			default: 'div',
		},
	},
	data() {
		return {
			items: [],
			currentItem: null,
		};
	},
	computed: {
		currentItemIndex() {
			return this.items.indexOf( this.currentItem );
		},
	},
	created() {
		// set item
		this.$on( 'set:item', this.setItem );
		// creates items
		this.$on( 'create:items', this.createItems );
		// carousel direction has callback which
		// is a string prop either previous or next
		this.$on( 'set:direction', ( direction ) => this[ `${ direction }Item` ]() );
	},
	methods: {
		setItem( item ) {
			this.currentItem = item;
		},
		createItems( item ) {
			this.items.push( item );
			if ( ! this.currentItem ) {
				this.setItem( item );
			}
		},
		nextItem() {
			this.setDirection( this.currentItemIndex + 1 );
		},
		previousItem() {
			this.setDirection( this.currentItemIndex - 1 );
		},
		setDirection( direction ) {
			const { items } = this;
			const { length } = items;
			const currentItem = items[ ( ( direction % length ) + length ) % length ];
			this.setItem( currentItem );
		},
	},
};
</script>
